import React from "react";
import type { DiscoveryInfluencerProfile } from "../../types/discoveryProfile.types";

export interface StatsRowProps {
  influencer: DiscoveryInfluencerProfile;
}

const formatNumber = (num: number): string => {
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
  if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";
  return num.toString();
};

export const StatsRow: React.FC<StatsRowProps> = ({ influencer }) => {
  const stats = [
    {
      label: "Total Followers",
      value: formatNumber(influencer.totalFollowers),
      icon: "/images/Dashboard/followers.png",
    },
    {
      label: "Total Following",
      value: influencer.totalFollowing ? formatNumber(influencer.totalFollowing) : "N/A",
      icon: "/images/Dashboard/following.png",
    },
    {
      label: "Total Posts",
      value: influencer.totalPosts ? formatNumber(influencer.totalPosts) : "N/A",
      icon: "/images/Dashboard/posts.png",
    },
    {
      label: "Engagement Rate",
      value: influencer.engagementRate ? formatNumber(influencer.engagementRate) : "N/A",
      icon: "/images/Dashboard/posts.png",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mt-8 px-6">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-white rounded-[20px] border border-gray-100 shadow-[0_4px_24px_rgba(0,0,0,0.03)] px-6 py-8 flex items-center justify-between"
        >
          {/* Left Content (Text) */}
          <div className="flex flex-col gap-2 ml-4">
            <p className="text-[20px] md:text-[34px] font-['Inter'] font-[700] italic text-[#593A82] leading-none">
              {stat.value}
            </p>
            <p className="text-[18px] text-black font-medium">
              {stat.label}
            </p>
          </div>

          {/* Right Content (Icon) */}
          <div className="w-[68px] h-[68px] rounded-full flex items-center justify-center flex-shrink-0 ml-4">
            <img
              src={stat.icon}
              alt={`${stat.label} icon`}
              className="w-[68px] h-[68px] object-contain"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsRow;
